import { Modal } from "@gs-ux-uitoolkit-react/modal";
import { ReactNode } from "react";
import type { ModalPlacement } from "@gs-ux-uitoolkit-react/modal";

type SlideModalProps = {
    /**
     * Flag which controls whether modal is open or closed
     */
    open: boolean;

    /**
     * Placement of the modal on the screen when it is open
     */
    placement: ModalPlacement;

    /**
     * Children to render inside the modal
     */
    children: ReactNode;
};

const SlideModal = ({ open, placement, children }: SlideModalProps) => (
    <Modal
        visible={open}
        placement={placement}
        className="w-full md:max-w-[90%] md:min-w-[80%] xs:min-w-[100%] md:h-[90vh] shadow-lg"
        classes={{
            content: "h-full flex flex-col grow",
            root: "overflow-auto w-full !p-0 !md:px-8 !md:py-10 !z-[10002]", // Required to not be hidden under MQ header
        }}>
        {children}
    </Modal>
);

export type { SlideModalProps };
export default SlideModal;
